import { render, staticRenderFns } from "./ChannelsSection.vue?vue&type=template&id=00261d50&scoped=true&"
import script from "./ChannelsSection.vue?vue&type=script&lang=js&"
export * from "./ChannelsSection.vue?vue&type=script&lang=js&"
import style0 from "./ChannelsSection.vue?vue&type=style&index=0&id=00261d50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00261d50",
  null
  
)

export default component.exports